import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { Button } from '../../../styles/common/Dialog';

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 10px;
  font-size: 14px;
  background-color: ${ColorSF2.white};
  min-height: 50px;
  @media (max-height: 530px) {
    margin: 1px 4px 1px 4px;
    font-size: 12px;
    min-height: 40px;
  }
`;

export const ButtonWrapper = styled(ItemWrapper)`
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: space-evenly;
`;

export const ItemTitle = styled.div`
  flex: 0 0 150px;
  padding: 10px;
  background-color: ${ColorSF2.lightGray};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  border-left: 1px solid ${ColorSF2.mediumGray};
  display: flex;
  align-items: center;
  padding-left: 10px;
`;
export const ItemInfo = styled.div`
  flex: 0 0 358px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  border-left: 1px solid ${ColorSF2.mediumGray};
  flex-wrap: wrap;
  word-break: break-all;
  @media (max-height: 530px) {
    flex: 0 0 400px;
  }
`;
export const RadioItemInfo = styled(ItemInfo)`
  justify-content: flex-start;
`;
export const InputArea = styled.input`
  width: 335px;
  line-height: 20px;
  background-color: ${props => props.isError && '#faa'};
`;
export const RadioArea = styled.input`
  background: #0375ff 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-right: 6.4px;
`;
export const RadioLabel = styled.label`
  text-align: left;
  font: normal normal normal 14px/1px Hiragino Kaku Gothic Pro;
  letter-spacing: 0px;
  opacity: 1;
  margin-right: 55.87px;
  line-height: 50px;
`;

export const CancelButton = styled(Button)`
  background: ${ColorSF2.white} 0% 0% no-repeat padding-box;
  color: ${ColorSF2.black};
  border: 1px solid ${ColorSF2.mediumGray};
`;
export const DeleteButton = styled(Button)`
  background: ${ColorSF2.red} 0% 0% no-repeat padding-box;
  color: ${ColorSF2.white};
`;
export const UpdateButton = styled(Button)`
  background: ${ColorSF2.navyBlue} 0% 0% no-repeat padding-box;
  color: ${ColorSF2.white};
`;
export const MessageWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 20px;
`;
export const MessageItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &:first-child {
    margin-bottom: 10px;
  }
`;
